<template>
    <div class="margin">
        <details>
            <summary @click="toggleIcon()">
                <i class="fa fa-fw aristotle-green" :class="{'fa-chevron-down': isOpen, 'fa-chevron-right': !isOpen}" />
                <a @click.stop :href="`#${content.name_plural}`">
                    {{ content.name_plural }} ({{ content.mapping.length }})
                </a>
            </summary>
            <ul>
                <li v-for="(metadataItem, metadataItemIndex) in content.mapping" :key="metadataItemIndex">
                    <a v-if="metadataItem.name instanceof Object"
                       :href="getElementHref(metadataItem.name.name, metadataItemIndex)"
                    >
                        {{ metadataItem.name.name }}
                    </a>
                    <a v-else :href="getElementHref(metadataItem.name, metadataItemIndex)">
                        {{ metadataItem.name }}
                    </a>
                </li>
            </ul>
        </details>
    </div>
</template>

<script>
export default {
    name: "TableElement",
    props: {
        content: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        isOpen: false,
    }),
    methods: {
        toggleIcon: function() {
            this.isOpen = !this.isOpen
        },
        getElementHref: (elementName, index) => {
            return `#${elementName}${index}`
        },
    },
}
</script>

<style scoped>
.margin {
    margin: 15px 20px;
}
li {
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>
